import { useQuery } from 'react-query';
import { handling as handlingApi } from '@afosto/fulfilment/api/Handling';

export const getHandlingListById = async (_, id) => {
  const response = await handlingApi.viewHandlingList(id);
  const { data } = response;

  return data;
};

export default (id, queryOptions = {}) =>
  useQuery(['handlingList', id], getHandlingListById, queryOptions);
